module.exports = __webpack_public_path__ + "assets/img/assistant-module3.5debf53f.png";